<template>
  <section
    id="hero"
    class="padding-y-3xl"
    style="background-color: var(--white); overflow: hidden"
  >
    <affiliate-hero
      v-if="isAffiliateReferral"
      :affiliate="affiliate"
    />
    <div
      v-else
      class="container"
    >
      <div class="row roomy">
        <div class="column-12">
          <h1>Here are the plans, Stan!</h1>
          <p class="size-xl line-length-md">
            We've got a Plan to get icons into any kind of project. Choose the one that works best for you and your team. Or
            <site-link :to="{ name: 'start' }">get started for Free</site-link>!
          </p>
        </div>
      </div>
      <div
        v-if="hasActiveOldPlan || hasNotOfferedPlan"
        class="row roomy margin-top-xl"
      >
        <div class="column-12">
          <div
            v-if="currentSubName === 'Employee'"
            class="message info"
          >
            <p style="--paragraph-margin-bottom: 0">
              <strong class="display-block">You've got the {{ currentSubName }} plan!</strong>
              <span class="display-block">You know, you're a real straight-shooter with "upper management" written all over you.</span>
            </p>
          </div>
          <div
            v-else
            class="message info"
          >
            <p style="--paragraph-margin-bottom: 0">
              <strong class="display-block">You've got the {{ currentSubName }} plan!</strong>
              <span class="display-block"
                >We no longer offer your plan to new subscribers. You can switch to one of the new plans below, or
                <a href="mailto:hello@fontawesome.com?subject=I have a question about my plan, Font Awesome!">contact us</a> with questions.</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import AffiliateHero from './../components/AffiliateHero'

  export default {
    name: 'PlansHeaderSection',

    components: {
      AffiliateHero
    },

    props: {
      isAffiliateReferral: {
        type: Boolean,
        default: false
      },
      affiliate: {
        type: Object
      },
      hasActiveOldPlan: {
        type: Boolean,
        default: false
      },
      hasNotOfferedPlan: {
        type: Boolean,
        default: false
      },
      currentSubName: {
        type: String
      }
    }
  }
</script>
